import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PageWrapperComponent } from './page-wrapper.component';

@NgModule({
  declarations: [PageWrapperComponent],
  imports: [CommonModule],
  exports: [PageWrapperComponent],
})
export class PageWrapperModule {}
